import { IMultipleIdsParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetProjectControlledPermissionsRequest
    extends Request<IMultipleIdsParams, IEmptyResult> {
  constructor(ids: string[]) {
    super('setProjectControlledPermissions', {
      ids: ids
    });
  }
}
